export const ru = {
  properties: {
    title: 'Свойства',
    position: 'Позиция',
    x: 'Позиция X',
    y: 'Позиция Y',
    rotation: 'Поворот',
    color: 'Цвет',
    number: 'Номер',
    name: 'Имя',
    team: 'Команда',
    otherNumber: 'Другой номер...',
    size: {
      title: 'Размер',
      small: 'Маленький',
      medium: 'Средний',
      large: 'Большой'
    },
    visibility: {
      show: 'Показать',
      hide: 'Скрыть',
      toggleAll: 'Скрыть'
    },
    actions: {
      applyToAll: 'Применить ко всем',
      delete: 'Удалить',
      lockPosition: 'Заблокировать позицию'
    }
  },
  toolbar: {
    newPage: 'Новая страница',
    open: 'Загрузить',
    save: 'Сохранить',
    addPlayer: 'Добавить игрока',
    addBall: 'Добавить мяч',
    addZone: 'Добавить зону',
    addArrow: 'Добавить стрелку',
    editField: 'Редактировать поле',
    exportVideo: 'Экспорт в видео',
    exportImage: 'Экспорт в PNG',
    backgroundColor: 'Цвет фона',
    changeLanguage: 'Изменить язык',
    login: 'Войти',
    logout: 'Выйти',
    share: {
      title: "Поделиться",
      cta: "Присоединиться",
      login: "Войти"
    },
    pricing: {
      title: "Наши цены",
      regularPrice: "65€ / год",
      specialOffer: "Специальное предложение",
      specialPrice: "37€ / год",
      payButton: "Оплатить подписку"
    },
    signup: {
      title: {
        step1: 'Создать аккаунт',
        step2: 'Завершить регистрацию'
      },
      country: 'Страна',
      language: 'Язык',
      success: {
        title: 'Регистрация успешна!',
        message: 'Письмо с подтверждением отправлено. Пожалуйста, проверьте вашу почту.',
        cta: 'Перейти к руководству'
      },
    },
    why: {
      title: 'Почему TACTICAFOOT',
      features: {
        simple: {
          title: 'Просто',
          description: 'TacticaFoot настолько прост, что вы уже знаете, как им пользоваться'
        },
        sync: {
          title: 'Синхронизация',
          description: 'Доступ к вашей тактике на всех устройствах'
        },
        rapide: {
          title: 'Быстро',
          description: 'Самое быстрое приложение для создания видео и изображений'
        },
        puissant: {
          title: 'Мощно',
          description: 'Дайте своей команде суперсилы'
        },
        accessible: {
          title: 'Доступно',
          description: 'TacticaFoot доступен везде, без установки'
        },
        secure: {
          title: 'Безопасно',
          description: 'Ваши данные защищены и сохранены'
        },
        intuitif: {
          title: 'Интуитивно',
          description: 'Плавный интерфейс, разработанный для тренеров'
        },
        evolutif: {
          title: 'Развивается',
          description: 'Улучшения каждую неделю'
        },
        collab: {
          title: 'Совместная работа',
          description: 'Отправляйте видео и изображения своим командам или персоналу'
        }
      }
    }
  },
  panels: {
    zone: {
      title: 'Зона',
      opacity: 'Прозрачность',
      fill: 'Цвет заливки',
      borderStyle: 'Стиль границы',
      strokeWidth: 'Ширина границы',
      strokeOpacity: 'Прозрачность границы',
      draggable: 'Перемещаемая',
      lock: 'Заблокировать зону',
      strokeColor: 'Цвет линии',
      fillColor: 'Цвет заливки',
      fillOpacity: 'Прозрачность заливки',
      dashArray: 'Стиль линии',
      solid: 'Сплошная',
      dashed: 'Пунктирная',
      dotted: 'Точечная',
      lockPosition: 'Заблокировать позицию'
    },
    player: {
      title: 'Игрок'
    },
    ball: {
      title: 'Мяч',
      size: 'Размер',
      color: 'Цвет',
      strokeColor: 'Цвет контура',
      hideStroke: 'Скрыть контур'
    },
    arrow: {
      title: 'Стрелка',
      strokeWidth: 'Толщина линии',
      strokeOpacity: 'Прозрачность линии',
      borderStyle: 'Стиль линии',
      color: 'Цвет',
      styles: {
        solid: 'Сплошная',
        dashed: 'Пунктирная',
        dotted: 'Точечная'
      }
    },
    training: {
      title: 'Оборудование',
      items: {
        Cone: 'Конус',
        Mannequin: 'Манекен',
        Goal: 'Ворота',
        Echelle: 'Лестница',
        Cerceau: 'Обруч',
        Coupelles: 'Фишки',
        Haies: 'Барьеры',
        Baton: 'Палка',
        'mini-goals': 'Мини-ворота',
        one: 'Этап 1',
        two: 'Этап 2',
        three: 'Этап 3',
        four: 'Этап 4',
        five: 'Этап 5'
      }
    },
    display: {
      title: 'Отображение',
      centralCircle: 'Центральный круг',
      centralPoint: 'Центральная точка',
      penaltyArea: 'Штрафная площадь',
      penaltyAreaArcs: 'Дуги штрафной',
      penaltyPoints: 'Точки пенальти',
      goalArea: 'Вратарская площадь',
      goals: 'Ворота',
      halfSpaces: 'Полупространства'
    }
  },
  footer: {
    rights: 'Все права защищены',
    contact: 'Контакты',
    legal: 'Правовая информация',
    otherTools: {
      title: 'Другие инструменты',
      features: 'Управление командой, Библиотека упражнений, Управление матчами и тренировками, Вызовы на матчи, Учет посещаемости'
    }
  },
  login: {
    title: 'Вход',
    fields: {
      email: 'Email',
      password: 'Пароль',
      showPassword: 'Показать пароль',
      hidePassword: 'Скрыть пароль',
      rememberMe: 'Запомнить меня'
    },
    buttons: {
      login: 'Войти',
      forgotPassword: 'Забыли пароль?',
      signup: 'Создать аккаунт'
    },
    errors: {
      invalidEmail: 'Неверный адрес электронной почты',
      userDisabled: 'Этот аккаунт был отключен',
      userNotFound: 'Аккаунт с таким адресом не найден',
      wrongPassword: 'Неверный пароль',
      default: 'Произошла ошибка при входе'
    },
    resetPassword: {
      title: 'Сбросить пароль',
      description: 'Введите ваш адрес электронной почты, и мы отправим вам ссылку для сброса пароля.',
      button: 'Отправить ссылку',
      cancel: 'Отмена',
      success: 'Email отправлен! Проверьте вашу почту.',
      error: 'Ошибка при отправке email. Проверьте ваш адрес электронной почты.'
    }
  }
};
